import { createAction, props } from '@ngrx/store';

import { SummaryFilters } from '@app/services/tickets.service';
import {
  ServiceSummaryStatsDetails,
  SummaryStatsGroup,
} from '@ui-components/components/summary-expandable-table/summary-expandable-table.model';

export const loadServiceSummaryStats = createAction(
  '[Service] Load Summary Stats',
  props<{ filter: SummaryFilters }>()
);
export const loadServiceSummaryStatsSuccess = createAction(
  '[Service] Load Summary Stats Success',
  props<{ stats: SummaryStatsGroup[] }>()
);
export const loadServiceSummaryStatsFailed = createAction(
  '[Service] Load Summary Stats Failed',
  props<{ error: any }>()
);

export const loadServiceSummaryDetails = createAction(
  '[Service] Load Summary Details',
  props<{ filter: SummaryFilters }>()
);
export const loadServiceSummaryDetailsSuccess = createAction(
  '[Service] Load Summary Details Success',
  props<{ details: ServiceSummaryStatsDetails }>()
);
export const loadServiceSummaryDetailsFailed = createAction(
  '[Service] Load Summary Details Failed',
  props<{ error: any }>()
);
